<template>
  <div class="filter-chip" :class="{ 'filter-chip--removable': removable }">
    <span class="filter-chip__label">{{ label }}</span>
    <button 
      v-if="removable" 
      class="filter-chip__remove"
      @click="$emit('remove')"
      :aria-label="`Remove ${label} filter`"
    >
      ×
    </button>
  </div>
</template>

<script>
export default {
  name: 'FilterChip',
  props: {
    label: {
      type: String,
      required: true
    },
    removable: {
      type: Boolean,
      default: true
    }
  },
  emits: ['remove']
}
</script>

<style scoped>
.filter-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: linear-gradient(135deg, rgba(45, 140, 240, 0.9) 0%, rgba(45, 140, 240, 0.7) 100%);
  border: 1px solid rgba(45, 140, 240, 0.4);
  border-radius: 20px;
  color: white;
  font-size: 12px;
  font-weight: 500;
  backdrop-filter: blur(8px);
  box-shadow: 0 2px 6px rgba(45, 140, 240, 0.2);
  transition: all 0.2s ease;
}

.filter-chip--removable:hover {
  background: linear-gradient(135deg, rgba(45, 140, 240, 1) 0%, rgba(45, 140, 240, 0.8) 100%);
  transform: translateY(-1px);
  box-shadow: 0 3px 8px rgba(45, 140, 240, 0.3);
}

.filter-chip__label {
  white-space: nowrap;
}

.filter-chip__remove {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border: none;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  color: white;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.2s ease;
  line-height: 1;
  padding: 0;
}

.filter-chip__remove:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.1);
}

.filter-chip__remove:focus {
  outline: 2px solid rgba(255, 255, 255, 0.5);
  outline-offset: 1px;
}
</style>